module.exports = "<md-dialog aria-label=\"Download\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Creating zip file' | translate}}</h2>\n            <md-progress-linear md-mode=\"indeterminate\"></md-progress-linear>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./sources/components/media/media-download/media-download.html
// module id = 775
// module chunks = 0